import React from "react";

export default class DMCA extends React.Component {
    render() {
        return(
            <div>DMCA</div>
        )
    };
}